/**
 * 
 */
var gstate = (function() {

    var version = '3.0.7';

    var ENV = undefined //options: LOCAL, DEV, TEST, PROD 
    var MERCHANT = undefined // options: coincurve, localcoin
    var MERCHANT_NAME = undefined
    var ETRANSFER_EMAIL = undefined
    var AUDIO_TOLL_FREE_NUMBER = undefined
    var TITLE = undefined
    var INPUT_ALLOWED = undefined
    var INPUT_BUY_ALLOWED = undefined
    var INPUT_SPEND_ALLOWED = undefined
    var INPUT_SELL_ALLOWED = undefined
    var ETRANSFER_FEE = undefined
    var ETRANSFER_FEE_PROMO = undefined
    var FLEXEPIN_FEE = undefined
    var FLEXEPIN_FEE_PROMO = undefined
    var ETRANSFER_FEE_PRO = undefined
    var OTC_FEE = undefined
    var SPEND_FEE = undefined
    var IS_PROMO = undefined
    var RECOMMENDED_WALLET = undefined
    var INPUT_FORM = undefined
    var SUPPORTED_FIAT_CURRENCIES = undefined
    var ACTIVE_FIAT_CURRENCY = undefined
    var ACTIVE_CRYPTO_CURRENCY = undefined
    var SHOW_TICKER = false
    var PSA = undefined
    var MOONPAY = undefined

    var API_OLD = '/pubapi/transaction';
    var API_AUDIO = '/pubapi/audio';
    var API_UPLOAD = '/pubapi/customerdoc';
    var API_ROOT = '/pubapi';

    var SITE_URL = undefined;
    var ERROR_URL = undefined;
    var SUCCESS_URL = undefined;
    var GTM = undefined;
    var PAYMENT_METHODS = undefined;
    var PAYMENT_METHOD_SUBTYPES = undefined;
    var SUPPORTED_COINS = undefined;

    var SHOW_LOGS = true; // show console logs

    var buyerInfo = {};
    var creditCardACS = {};
    var cryptoAddress = '';
    var emtEmailAddress = '';
    var paymentMethod = '';
    var isVerified = false;
    var isProFlow = false;
    var txnType = undefined; // SPEND, BUY, SELL
    var paymentAction = undefined;

    var flowState;

    var addressRequired = false;

    function prv_init() {
        flowState = {};
        buyerInfo = {};
    }

    function redirect(url) {
        window.location.href = url;
    }

    return {
        init: function() {

            // force disable logging and debug input if on prod
            if (ENV == 'PROD') {
                SHOW_LOGS = false;
            }
            prv_init();
        },
        saveConfig(config) {

            ENV = config.env;
            MERCHANT = config.merchant;
            MERCHANT_NAME = config.merchantName;
            ETRANSFER_EMAIL = config.etransferEmail;
            AUDIO_TOLL_FREE_NUMBER = config.audioTollFreeNumber;
            TITLE = config.title;
            INPUT_ALLOWED = config.inputAllowed;
            INPUT_BUY_ALLOWED = config.inputBuyAllowed;
            INPUT_SPEND_ALLOWED = config.inputSpendAllowed;
            INPUT_SELL_ALLOWED = config.inputSellAllowed;
            ETRANSFER_FEE = config.etransferFee;
            ETRANSFER_FEE_PROMO = config.etransferFeePromo;
            FLEXEPIN_FEE = config.flexepinFee;
            FLEXEPIN_FEE_PROMO = config.flexepinFeePromo;
            ETRANSFER_FEE_PRO = config.etransferFeePro;
            OTC_FEE = config.otcFee;
            SPEND_FEE = config.spendFee;
            IS_PROMO = config.isPromo;
            SITE_URL = config.siteUrl;
            ERROR_URL = config.errorUrl;
            SUCCESS_URL = config.successUrl;
            GTM = config.gtm;
            PAYMENT_METHODS = config.paymentMethods;
            PAYMENT_METHOD_SUBTYPES = config.paymentMethodSubtypes;
            SUPPORTED_COINS = config.supportedCoins;
            RECOMMENDED_WALLET = config.recommendedWallet;
            INPUT_FORM = config.inputForm;
            SUPPORTED_FIAT_CURRENCIES = config.supportedFiatCurrencies;
            SHOW_TICKER = config.showTicker;
            PSA = config.psa
            MOONPAY = config.moonpay

        },
        saveBuyerInfo: function(bi) {
            buyerInfo = bi;
        },
        saveCryptoAddress: function(address) {
            cryptoAddress = address;
        },
        saveEmtEmailAddress: function(address) {
            emtEmailAddress = address;
        },
        saveCreditCardACS: function(data) {
            creditCardACS = data;
        },
        savePaymentAction: function(pa) {
            paymentAction = pa;
        },
        getPaymentAction: function() {
            return paymentAction;
        },
        getCreditCardACS: function() {
            return creditCardACS;
        },
        getMoonpayApiKey: function() {
            if (MOONPAY.apiKey == undefined) {
                this.log("API key not defined.  API key cannot be missing.");
            }
            return MOONPAY.apiKey;
        },
        getMoonpayColorCode: function() {
            if (MOONPAY.colorCode == undefined) {
                this.log("Color code not defined.  Using default color code.");
                return "#9bcb6c";
            }
            return MOONPAY.colorCode;
        },
        getMoonpayBaseURL: function() {
            if (MOONPAY.baseUrl == undefined) {
                this.log("Base URL not defined.  Using default staging url.");
                return "https://buy-staging.moonpay.io";
            }
            return MOONPAY.baseUrl;
        },
        setVerified: function() {
            isVerified = true;
        },
        getVerified: function() {
            return isVerified;
        },
        getRefId: function() {
            return flowState.refId;
        },
        saveMobileCode: function(mobileCode) {
            buyerInfo.mobileCode = mobileCode;
        },
        getMobileCode: function() {
            return buyerInfo.mobileCode;
        },
        getBuyerInfo: function() {
            return buyerInfo;
        },
        getCryptoAddress: function() {
            return cryptoAddress;
        },
        getEmtEmailAddress: function() {
            return emtEmailAddress;
        },
        getPaymentMethod: function() {
            return this.getFlowState().paymentMethod;
        },
        setPaymentMethodSubtype: function(type) {
            this.paymentMethodSubtype = type;
        },
        getPaymentMethodSubtype: function() {
            return this.paymentMethodSubtype;
        },
        getApiBaseURL: function() {

            if (this.txnType == 'BUY') {
                return API_ROOT + '/txnbuy';
            } else if (this.txnType == 'SELL') {
                return API_ROOT + '/txnsell';
            }

            return API_ROOT + '/txnbuy';
        },
        getOldApiBaseURL: function() {
            return API_OLD;
        },
        getAudioApiBaseURL: function() {
            return API_AUDIO;
        },
        getUploadApiBaseURL: function() {
            return API_UPLOAD;
        },
        getApiBaseRootURL: function() {
            return API_ROOT;
        },
        getSiteURL: function() {

            if (this.isCoincurve() && this.getActiveFiatCurrency() == 'PHP') {
                return SITE_URL + "/ph";
            } else if (this.isCoincurve() && this.getActiveFiatCurrency() == 'AUD') {
                return SITE_URL + "/au";
            }

            return SITE_URL;
        },
        getErrorURL: function() {

            if (ERROR_URL === undefined) {
                return this.getSiteURL();
            } else {

                if (this.isCoincurve() && this.getActiveFiatCurrency() == 'PHP') {
                    return ERROR_URL + "/ph";
                } else if (this.isCoincurve() && this.getActiveFiatCurrency() == 'AUD') {
                    return ERROR_URL + "/au";
                }

                return ERROR_URL;
            }

        },
        getSuccessURL: function() {

            if (SUCCESS_URL === undefined) {
                return this.getSiteURL();
            } else {

                if (this.isCoincurve() && this.getActiveFiatCurrency() == 'PHP') {
                    return SUCCESS_URL + "/ph";
                } else if (this.isCoincurve() && this.getActiveFiatCurrency() == 'AUD') {
                    return SUCCESS_URL + "/au";
                }

                return SUCCESS_URL;
            }

        },
        getRecommendedWallet: function() {
            return RECOMMENDED_WALLET;
        },
        getDefaultBuyAmount: function() {
            if (INPUT_FORM == undefined || INPUT_FORM.defaultBuy == undefined) {
                return 20;
            }

            if (INPUT_FORM[this.getActiveFiatCurrency()] != undefined) {
                return INPUT_FORM[this.getActiveFiatCurrency()].default;
            }

            return INPUT_FORM.defaultBuy;
        },
        getDefaultSellAmount: function() {
            if (INPUT_FORM == undefined || INPUT_FORM.defaultSell == undefined) {
                return 0.0015;
            }

            if (INPUT_FORM[this.getActiveCryptoCurrency()] != undefined) {
                return INPUT_FORM[this.getActiveCryptoCurrency()].default;
            }

            return INPUT_FORM.defaultSell;
        },
        getMinAmount: function(type, method) {

            let activeCurrency;
            if (type == 'BUY') {
                activeCurrency = this.getActiveFiatCurrency();
            } else if (type == 'SELL') {
                if (method == 'GIFTCARD') {
                    activeCurrency = this.getActiveFiatCurrency();
                } else {
                    activeCurrency = this.getActiveCryptoCurrency();
                }

            }

            if (INPUT_FORM == undefined || INPUT_FORM.min == undefined) {
                return 0;
            }

            if (INPUT_FORM[activeCurrency] != undefined) {
                return INPUT_FORM[activeCurrency].min;
            }

            return INPUT_FORM.min;
        },
        getMaxAmount: function(type, method) {

            let activeCurrency;
            if (type == 'BUY') {
                activeCurrency = this.getActiveFiatCurrency();
            } else if (type == 'SELL') {
                if (method == 'GIFTCARD') {
                    activeCurrency = this.getActiveFiatCurrency();
                } else {
                    activeCurrency = this.getActiveCryptoCurrency();
                }

            }

            if (INPUT_FORM == undefined || INPUT_FORM.max == undefined) {
                return 500;
            }

            if (INPUT_FORM[activeCurrency] != undefined) {
                return INPUT_FORM[activeCurrency].max;
            }

            return INPUT_FORM.max;
        },
        getGTM: function() {
            return GTM;
        },
        redirectHome: function(errorCode = "", time = 5000, log = '') {

            // Error codes:
            // 100 - Transaction Cancelled
            // 200 - Transaction Timed Out
            // 300 - Internal Server Error

            var url = this.getSiteURL();

            if (errorCode != "") {
                url = this.getErrorURL();
                url += "?err=" + errorCode;
            }

            if (log != '') {
                this.log(log);
            }

            setTimeout(redirect, time, url);
        },
        redirectSuccess: function(time = 0) {
            var url = this.getSuccessURL();
            setTimeout(redirect, time, url);
        },
        getEnv: function() {
            return ENV;
        },
        isDev: function() {
            if (ENV == 'DEV') {
                return true;
            }

            return false;
        },
        isProd: function() {
            if (ENV == 'PROD') {
                return true;
            }

            return false;
        },
        isTest: function() {
            if (ENV == 'TEST') {
                return true;
            }

            return false;
        },
        getMerchant: function() {
            return MERCHANT;
        },
        getMerchantName: function() {
            return MERCHANT_NAME;
        },
        getEtransferEmail: function() {
            return ETRANSFER_EMAIL;
        },
        getAudioTollFreeNumber: function() {
            return AUDIO_TOLL_FREE_NUMBER;
        },
        getTitle: function() {
            return TITLE;
        },
        getInputAllowed: function() {
            if (INPUT_ALLOWED == undefined) {
                return false;
            }

            return INPUT_ALLOWED;
        },
        getInputBuyAllowed: function() {
            if (INPUT_BUY_ALLOWED == undefined) {
                return false;
            }

            return INPUT_BUY_ALLOWED;
        },
        getInputSpendAllowed: function() {
            if (INPUT_SPEND_ALLOWED == undefined) {
                return false;
            }

            return INPUT_SPEND_ALLOWED;
        },
        getInputSellAllowed: function() {
            if (INPUT_SELL_ALLOWED == undefined) {
                return false;
            }

            return INPUT_SELL_ALLOWED;
        },
        getEtransferFee: function() {
            if (this.isPromo()) {
                return ETRANSFER_FEE_PROMO;
            }
            return ETRANSFER_FEE;
        },
        getFlexepinFee: function() {
            if (this.isPromo()) {
                return FLEXEPIN_FEE_PROMO;
            }
            return FLEXEPIN_FEE;
        },
        getEtransferFeePro: function() {
            return ETRANSFER_FEE_PRO;
        },
        getEtransferFeeOrig: function() {
            return ETRANSFER_FEE;
        },
        getFlexepinFeeOrig: function() {
            return FLEXEPIN_FEE;
        },
        getEtransferFeePromo: function() {
            return ETRANSFER_FEE_PROMO;
        },
        getFlexepinFeePromo: function() {
            return FLEXEPIN_FEE_PROMO;
        },
        isPromo: function() {
            if (IS_PROMO === undefined || this.isProFlow()) {
                return false;
            }

            return IS_PROMO
        },
        getOtcFee: function() {
            return OTC_FEE;
        },
        getSpendFee: function() {
            return SPEND_FEE;
        },
        merchant(merchant) {

            if (MERCHANT == merchant) {
                return true;
            }

            return false;
        },
        clearFlowState: function() {
            flowState = {};
        },
        getAxiosHeaders: function() {
            return {
                headers: {
                    'Content-Type': 'application/json'
                }
            };
        },
        log: function(str) {
            if (SHOW_LOGS) {
                console.log(str);
            } else {
                console.log(str);
            }
        },
        getVersion: function() {
            return version;
        },
        setProFlow: function(param) {
            isProFlow = param;
        },
        isProFlow: function() {
            return isProFlow;
        },
        isCoincurve: function() {
            if (MERCHANT == 'Coincurve' || MERCHANT == 'DevCoincurve' || MERCHANT == 'CoincurvePro') {
                return true;
            }

            return false;
        },
        setTxnType: function(type) {
            this.txnType = type;
        },
        getTxnType: function() {
            return this.txnType;
        },
        getPaymentMethods: function() {
            return PAYMENT_METHODS;
        },
        getPaymentMethodSubtypes: function() {
            return PAYMENT_METHOD_SUBTYPES;
        },
        getPaymentMethodObj: function(key) {
            return PAYMENT_METHODS[key];
        },
        getPaymentMethodSubtypeObj: function(key) {
            return PAYMENT_METHOD_SUBTYPES[key];
        },
        getPaymentMethodName: function(key) {
            if (PAYMENT_METHODS[key] !== undefined) {
                return PAYMENT_METHODS[key].name;
            }

            return "N/A";
        },
        getPaymentMethodSubtypeName: function(key) {
            if (PAYMENT_METHOD_SUBTYPES[key] !== undefined) {
                return PAYMENT_METHOD_SUBTYPES[key].name;
            }

            return "N/A";
        },
        getPaymentMethodAmounts: function(key) {
            if (PAYMENT_METHODS[key] !== undefined) {
                return PAYMENT_METHODS[key].amounts;
            }

            return undefined;
        },
        getPaymentMethodSubtypeAmounts: function(key) {
            if (PAYMENT_METHOD_SUBTYPES[key] !== undefined) {
                return PAYMENT_METHOD_SUBTYPES[key].amounts;
            }

            return undefined;
        },
        isValidPaymentMethod: function(param) {
            if (PAYMENT_METHODS[param] === undefined) {
                return false;
            }

            return true;
        },
        getBuyPaymentMethods: function() {
            var m = {};
            for (const [key, value] of Object.entries(PAYMENT_METHODS)) {
                if (value.type == "BUY") {
                    m[key] = value;
                }
            }
            return m;
        },
        getNumBuyPaymentMethods: function() {
            if (PAYMENT_METHODS == undefined) {
                return 1;
            } else {
                return Object.keys(this.getBuyPaymentMethods()).length;
            }
        },
        getDefaultBuyPaymentMethod: function() {
            return Object.keys(this.getBuyPaymentMethods())[0];
        },
        getSellPaymentMethods: function() {
            var m = {};
            for (const [key, value] of Object.entries(PAYMENT_METHODS)) {
                if (value.type == "SELL") {
                    m[key] = value;
                }
            }
            return m;
        },
        getNumSellPaymentMethods: function() {
            if (PAYMENT_METHODS == undefined) {
                return 1;
            } else {
                return Object.keys(this.getSellPaymentMethods()).length;
            }
        },
        getDefaultSellPaymentMethod: function() {
            return Object.keys(this.getSellPaymentMethods())[0];
        },
        getSpendPaymentMethods: function() {
            var m = {};
            for (const [key, value] of Object.entries(PAYMENT_METHODS)) {
                if (value.type == "SPEND") {
                    m[key] = value;
                }
            }
            return m;
        },
        getDefaultSpendPaymentMethod: function() {
            return Object.keys(this.getSpendPaymentMethods())[0];
        },
        getSupportedCoins: function() {
            return SUPPORTED_COINS;
        },
        getNumSupportedCoins: function() {
            if (SUPPORTED_COINS == undefined) {
                return 1;
            } else {
                return Object.keys(SUPPORTED_COINS).length;
            }
        },
        getSupportedCoin: function(key) {
            return SUPPORTED_COINS[key];
        },
        getDefaultSupportedCoin: function() {
            if (SUPPORTED_COINS == undefined) {
                return { "id": "BTC", "name": "Bitcoin" };
            } else {
                return SUPPORTED_COINS[Object.keys(SUPPORTED_COINS)[0]];
            }
        },
        getDefaultSupportedFiatCurrency: function() {
            if (SUPPORTED_FIAT_CURRENCIES == undefined) {
                return { "id": "CAD", "symbol": "$" };
            } else {
                return SUPPORTED_FIAT_CURRENCIES[Object.keys(SUPPORTED_FIAT_CURRENCIES)[0]];
            }
        },
        getSupportedFiatCurrencies: function() {
            if (SUPPORTED_FIAT_CURRENCIES == undefined) {
                return { "CAD": { "id": "CAD", "symbol": "$" } };
            }

            return SUPPORTED_FIAT_CURRENCIES;
        },
        getNumSupportedFiatCurrencies: function() {
            if (SUPPORTED_FIAT_CURRENCIES == undefined) {
                return 1;
            } else {
                return Object.keys(SUPPORTED_FIAT_CURRENCIES).length;
            }
        },
        getCurrencySymbol: function(key) {
            if (SUPPORTED_FIAT_CURRENCIES == undefined) {
                return '$';
            } else {
                return SUPPORTED_FIAT_CURRENCIES[key].symbol;
            }
        },
        getActiveFiatCurrency: function() {
            if (ACTIVE_FIAT_CURRENCY == undefined) {
                return 'CAD';
            }

            return ACTIVE_FIAT_CURRENCY;
        },
        setActiveFiatCurrency: function(currency) {
            ACTIVE_FIAT_CURRENCY = currency;
        },
        getActiveCryptoCurrency: function() {
            if (ACTIVE_CRYPTO_CURRENCY == undefined) {
                return 'BTC';
            }

            return ACTIVE_CRYPTO_CURRENCY;
        },
        setActiveCryptoCurrency: function(currency) {
            ACTIVE_CRYPTO_CURRENCY = currency;
        },
        getActiveCountry: function() {

            if (this.getActiveFiatCurrency() == 'CAD') {
                return 'CA';
            } else if (this.getActiveFiatCurrency() == 'PHP') {
                return 'PH';
            } else if (this.getActiveFiatCurrency() == 'IDR') {
                return 'ID';
            } else if (this.getActiveFiatCurrency() == 'AUD') {
                return 'AU';
            }

        },
        showTicker() {

            if (SHOW_TICKER == undefined) {
                return false;
            }

            return SHOW_TICKER;
        },
        getPSA() {
            if (PSA == undefined) {
                return false
            }

            return PSA
        },
        performNextAction(vue) {
            this.log('performNextAction()');
            this.log(flowState);
            this.log('next action: ' + flowState.nextAction);
            var action = '';
            switch (flowState.nextAction) {
                case "INPUT_CRYPTOADDRESS":

                    // get current screen, if on quote screen, go to address, otherwise go to price-quote
                    if (vue.$route.name == "price-quote") {
                        action = '/address-input';
                    } else {
                        action = '/price-quote';
                    }

                    break;

                case "INPUT_BUYERINFO":

                    // get current screen, if on quote screen, go to buyer info input, otherwise go to price-quote
                    if (this.getPaymentMethod() == 'ETRANSFEROUT') {
                        if (vue.$route.name == "price-quote") {
                            action = '/buyer-info-input';
                        } else {
                            action = '/price-quote';
                        }
                    } else if (this.getPaymentMethod() == 'GIFTCARD') {
                        if (vue.$route.name == "price-quote") {
                            action = '/buyer-info-input';
                        } else {
                            action = '/spend-quote';
                        }
                    } else {
                        action = '/buyer-info-input';
                    }

                    break;

                case "VERIFY_MOBILE":
                    action = '/mobile-verification';
                    break;

                case "SUBMIT_SELFIEDOC":
                    action = '/image-input-choice';
                    break;

                case "ADMIN_REVIEW":
                    action = '/transaction-in-review';
                    break;

                case "INPUT_VOUCHERNUMBER":
                    action = '/payment-flexepin';
                    break;

                case "CUSTOMER_PAYMENT":
                    if (this.getPaymentMethod() == 'OTC') {
                        action = '/payment-otc'
                    } else if (this.getPaymentMethod() == 'BANKTRANSFER') {

                        if (this.getFlowState().fiatCurrency == 'AUD') {
                            redirect(this.getFlowState().nextActionParams.redirectUrl);
                        } else {
                            document.write(this.getFlowState().nextActionParams.htmlDoc);
                        }

                    } else if (this.getPaymentMethod() == 'ETRANSFER') {
                        action = '/payment-etransfer-instructions'
                    }
                    break;

                case "INITIATE_BANKTRANSFER":

                    if (this.getFlowState().fiatCurrency == 'AUD') {
                        action = '/poli'
                    } else {
                        action = '/bank-select'
                    }

                    break;
                case "INITIATE_ETRANSFER":
                    action = '/payment-etransfer-instructions'
                    break;

                case "INPUT_EMTEMAIL":
                    action = '/email-input'
                    break;

                case "DONE_COMPLETED":
                    action = '/transaction-success'
                    break;

                case "DONE_CANCELLED":
                    action = '/transaction-cancelled'
                    break;
                default:
                    this.log('"' + flowState.nextAction + '" has no action attached :(');
                    break;

            }

            if (action != '') {
                this.log('route: ' + action);
            }

            vue.$router.push(action)
        },
        saveFlowState(response) {
            this.log("saveFlowState()");
            flowState = response;

            if (flowState.nextActionParams != undefined && flowState.nextActionParams.addressRequired != undefined) {
                addressRequired = flowState.nextActionParams.addressRequired
            }

        },
        getFlowState() {
            return flowState;
        },
        saveFlowStateAndProceed(response, vueinst) {
            this.log('saveFlowStateAndProceed');
            if (vueinst == null) {
                this.log('Vue cannot be null. Pass in vue instance.');
            }

            this.saveFlowState(response);
            this.performNextAction(vueinst);
        },
        requiresAddressInput: function() {
            return addressRequired;
        },
    }
})();
export default gstate;